export function convertTime(twentyFourHourTime: string): {
	time: string;
	meridian: 'AM' | 'PM';
} | null {
	const [hours, minutes] = twentyFourHourTime.split(':');
	if (!hours || !minutes) {
		// if the time is not in the correct format, return null
		return null;
	}

	const hoursNum = parseInt(hours, 10);

	if (Number.isNaN(hoursNum) || hoursNum < 0 || hoursNum > 23) {
		// if the hours are not a valid number, return null
		return null;
	}

	// mod 12 to get the twelve hour time, but zero becomes 12
	const twelveHourTime = ((hoursNum + 11) % 12) + 1;
	return {
		time: `${String(twelveHourTime).padStart(2, '0')}:${minutes}`,
		meridian: hoursNum < 12 ? 'AM' : 'PM',
	};
}
